// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  position: relative;
}

ion-grid,
ion-row,
ion-col {
  padding: 0;
}

ion-icon {
  font-size: 22px;
}

.footer {
  height: 40px;
  background: whitesmoke !important;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.footer-gateway {
  max-height: 40px;
}

.footer-telegram {
  max-width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 5px;
  word-wrap: break-word;
}

.footer-last-telegram {
  color: black;
  white-space: nowrap;
  font-size: 12px;
  padding-right: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
}

.gateway-name {
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/footer/footer.component.scss","webpack://./src/components/general%20components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;;;EAGE,UAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADGA;EACE,YAAA;EACA,iCAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;ACAF;;ADGA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;ACAF;;ADGA;EACE,0BAAA;ACAF","sourcesContent":["ion-toolbar {\n  position: relative;\n}\n\nion-grid,\nion-row,\nion-col {\n  padding: 0;\n}\n\nion-icon {\n  font-size: 22px;\n}\n\n\n.footer {\n  height: 40px;\n  background: whitesmoke !important;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n}\n\n.footer-gateway {\n  max-height: 40px;\n}\n\n.footer-telegram {\n  max-width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 5px;\n  word-wrap:break-word;\n}\n\n.footer-last-telegram {\n  color: black;\n  white-space: nowrap;\n  font-size: 12px;\n  padding-right: 5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  word-wrap:break-word;\n} \n\n.gateway-name{\n  text-transform: capitalize;\n}","ion-toolbar {\n  position: relative;\n}\n\nion-grid,\nion-row,\nion-col {\n  padding: 0;\n}\n\nion-icon {\n  font-size: 22px;\n}\n\n.footer {\n  height: 40px;\n  background: whitesmoke !important;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n}\n\n.footer-gateway {\n  max-height: 40px;\n}\n\n.footer-telegram {\n  max-width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 5px;\n  word-wrap: break-word;\n}\n\n.footer-last-telegram {\n  color: black;\n  white-space: nowrap;\n  font-size: 12px;\n  padding-right: 5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n\n.gateway-name {\n  text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
